import { constants } from '@dxp-module/common';
function getAuthenticationName() {
    const { DIMENSIONS: { brand, country, region }, } = constants;
    return `DXP_SAUT_${brand}_${country}_${region}`;
}
export const tokenService = {
    store: (token) => {
        localStorage.setItem(getAuthenticationName(), token);
    },
    getCurrentToken: () => {
        return localStorage.getItem(getAuthenticationName());
    },
    removeCurrentToken: () => {
        localStorage.removeItem(getAuthenticationName());
    },
};
//# sourceMappingURL=tokenService.js.map